import NWSAlertsList from 'components/StormCenter/displays/NWSAlertsList';
import { useState } from 'react';
import { useGetAllActiveAlertsQuery } from 'services/alerts/alerts.api';
import { ErrorMessage } from './ErrorMessage';
import WidgetLoadingAnimation from './WidgetLoadingAnimation';
import WidgetTimeUpdate from './WidgetTimeUpdate';

export default function NWSAlertsWidget({ widgetRefresh, setWidgetRefresh, dimensions }) {
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState({ state: false, message: '' });
  const { data: allActiveAlerts = [] } = useGetAllActiveAlertsQuery();
  const cwAlertsOnly = allActiveAlerts?.filter((alert) => alert.provider === 'Custom Weather');
  const ROUTE = 'getAllActiveAlerts';

  if (error.state && !fetching) {
    return (
      <ErrorMessage
        message={error.message}
        retryRoute={ROUTE}
        onRetry={() => {
          setError({ state: false, message: '' });
          setFetching(true);
        }}
      />
    );
  }

  // if (true)
  if (fetching) return <WidgetLoadingAnimation widgetName={'NWSAlerts'} dimensions={dimensions} />;

  if (cwAlertsOnly && cwAlertsOnly.length === 0) {
    return (
      <div>
        <WidgetTimeUpdate route={ROUTE} realtime />
        <div style={{ padding: 15 }}>No data found.</div>
      </div>
    );
  }

  if (dimensions[0] == 1 && dimensions[1] == 2)
    return (
      <div style={{ height: '100%' }}>
        <WidgetTimeUpdate route={'getAllActiveAlerts'} realtime />
        <div
          style={{
            height: 'calc(100% - 20px)',
            overflowX: 'hidden',
          }}
        >
          {' '}
          <NWSAlertsList />{' '}
        </div>
      </div>
    );
  if (dimensions[0] == 1 && dimensions[1] == 1)
    return (
      <div style={{ height: '100%' }}>
        <WidgetTimeUpdate route={'getAllActiveAlerts'} realtime />
        <div
          style={{
            height: 'calc(100% - 20px)',
            overflowX: 'hidden',
          }}
        >
          {' '}
          <NWSAlertsList />{' '}
        </div>
      </div>
    );

  if (dimensions[0] == 2 && dimensions[1] == 1)
    return (
      <div style={{ height: '100%' }}>
        <WidgetTimeUpdate route={'getAllActiveAlerts'} realtime />
        <div
          style={{
            height: 'calc(100% - 20px)',
            overflowX: 'hidden',
          }}
        >
          {' '}
          <NWSAlertsList />{' '}
        </div>
      </div>
    );
}

